export default __webpack_public_path__ + "static/media/dummy-logo.d623f13a.png";